export class MongoAtlasClusterResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterTier",
            "baseName": "clusterTier",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterType",
            "baseName": "clusterType",
            "type": "string",
            "format": ""
        },
        {
            "name": "mongoVersion",
            "baseName": "mongoVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageIops",
            "baseName": "storageIops",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasClusterResource.attributeTypeMap;
    }
    constructor() {
    }
}
